export const url = { API_URL: process.env.REACT_APP_SERVER };

export const notificationSocketUrl = {
  API_URL: process.env.REACT_APP_SERVER,
};
